import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { api } from '@shared/api/client';
import { TASKS } from '@shared/api/endpoints';
import { useApprovalBadgeStore } from '@shared/stores/approvalBadgeStore';
import type { ApprovalEntry } from '@tailorcast/shared-types';

export function useApprovalBadgePoller() {
  const setCount = useApprovalBadgeStore((s) => s.setCount);

  const { data } = useQuery({
    queryKey: ['approvals', 'pending', 'badge'],
    queryFn: () => api.get<{ approvals: ApprovalEntry[] }>(TASKS.APPROVALS_PENDING),
    refetchInterval: 5000,
  });

  useEffect(() => {
    if (data?.approvals) {
      setCount(data.approvals.length);
    }
  }, [data, setCount]);
}
